import { View, Text, Pressable, ActivityIndicator } from 'react-native';
import { blockyStrikerViewStyles as styles } from './BlockyStrikerView.styles';
import { BLOCKY_STRIKER_ACCENT, BLOCKY_STRIKER_TEST_IDS } from '../../../src/quiz/constants/blockyStriker.constants';

interface BlockyStrikerOverlaysProps {
  status: 'loading' | 'ready' | 'error';
  onRetry: () => void;
}

/**
 * The host-side overlay layer: loading until the runtime posts `ready`, error + Retry on `load-error`.
 * Everything else (Kick Off, HUD, game over, restart) is drawn by the game canvas itself.
 */
export function BlockyStrikerOverlays({ status, onRetry }: BlockyStrikerOverlaysProps) {
  if (status === 'loading') {
    return (
      <View style={styles.overlay} testID={BLOCKY_STRIKER_TEST_IDS.loading} pointerEvents="none">
        <ActivityIndicator color={BLOCKY_STRIKER_ACCENT} />
      </View>
    );
  }
  if (status === 'error') {
    return (
      <View style={styles.overlay} testID={BLOCKY_STRIKER_TEST_IDS.error}>
        <Text style={styles.message}>Could not load the game</Text>
        <Pressable
          testID={BLOCKY_STRIKER_TEST_IDS.retry}
          onPress={onRetry}
          style={({ pressed }) => [styles.retryButton, pressed && styles.pressedDim]}
        >
          <Text style={styles.retryText}>Retry</Text>
        </Pressable>
      </View>
    );
  }
  return null;
}
